import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { TabContext, TabPanel } from "@mui/lab";
import { Box, Typography } from "@mui/material";
import { t } from "i18next";
import TrainHistory from "../components/train/TrainHistory";

export default function TrainHistoryPage() {
  const { id } = useParams();
  const [value, setValue] = useState<string>("all");
  // const [sortOption, setSortOption] = useState<string>("all");

  return (
    <Box sx={{ mt: "20px" }}>
      <Box
        sx={{
          width: "1200px",
          display: "flex",
          flexDirection: "column",
          // alignItems: "center",
          gap: 2,
        }}
      >
        <Typography variant="h4">{t("History")}</Typography>
        <TrainHistory />
      </Box>
    </Box>
  );
}
